export default __webpack_public_path__ + "static/media/ADCover.65ec1603.jpeg";